// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cD45","left":"styles_left__3UzAK","desktopActions":"styles_desktopActions__1WkDC","title":"styles_title__3GEi9"};